import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Box from 'components/box'

import styles from './box-list.css'

const BoxList = ({ items, padding }) => (
  <div styleName="box-list">
    {items.map((item, i) => (
      <Box
        interactive
        first={i === 0}
        key={i}
        last={i === items.length - 1}
        padding={padding}
        single={items.length === 1}
      >
        {item}
      </Box>
    ))}
  </div>
)

BoxList.propTypes = {
  items: PropTypes.array,
  padding: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
}

export default CSSModules(BoxList, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/box-list/box-list.js
 **/